import { render, staticRenderFns } from "./partnerDir.vue?vue&type=template&id=3de6bd89"
import script from "./partnerDir.vue?vue&type=script&lang=js"
export * from "./partnerDir.vue?vue&type=script&lang=js"
import style0 from "./partnerDir.vue?vue&type=style&index=0&id=3de6bd89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports